import classNames from 'classnames';
import './InfoSection.scss';

const InfoSection = ({
  titleText = '',
  subtitle,
  descriptionText = '',
  titleStyles,
  titleIcon,
  iconStyles,
  descriptionLinkText = '',
  descriptionLinkClick = null,
  subtitleStyles,
}) => (
  <div className="InfoSection">
    <div className={classNames('InfoSection__title', titleStyles)}>
      {titleIcon && (
        <img
          className={classNames('InfoSection__icon', iconStyles)}
          src={titleIcon}
          alt="icon"
        />
      )}
      {titleText}
    </div>
    {subtitle && (
      <div className={classNames('InfoSection__subtitle', subtitleStyles)}>{subtitle}</div>
    )}
    {descriptionText && (descriptionLinkText ? (
      <p className="InfoSection__description">

        {descriptionText}

        {' '}
        <span
          className="InfoSection__description_link"
          onKeyDown={descriptionLinkClick}
          onClick={descriptionLinkClick}
          role="button"
          tabIndex="0"
        >
          {descriptionLinkText}
        </span>

      </p>
    ) : (
      <div className="InfoSection__description">{descriptionText}</div>
    ))}
  </div>
);

export default InfoSection;
